<mat-card appearance="outlined" class="card">
  <mat-card-actions>
    <div class="flex-row start-center gap-20">
      <button matButton="elevated" color="primary" (click)="onAddStatus()">
        <mat-icon>add</mat-icon>
        <span i18n>Add Status</span>
      </button>
      <button matButton="elevated" (click)="onBack()">
        <mat-icon>arrow_back</mat-icon>
        <span i18n>Back</span>
      </button>
    </div>
  </mat-card-actions>
  <br />
  <mat-card-content>
    <mat-form-field>
      <mat-label i18n="@filter">Filter</mat-label>
      <input matInput (keyup)="applyFilter($event)" #input />
    </mat-form-field>
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      matSortActive="metaId"
      matSortDirection="asc"
    >
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>
          Status Name
        </th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>
      <ng-container matColumnDef="externalId">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          i18n="@@externalId"
        >
          External Id
        </th>
        <td mat-cell *matCellDef="let element">{{ element.externalId }}</td>
      </ng-container>
      <ng-container matColumnDef="metaId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@metaId">
          Meta Id
        </th>
        <td mat-cell *matCellDef="let element">{{ element.metaId }}</td>
      </ng-container>
      <ng-container matColumnDef="nextStatuses">
        <th mat-header-cell *matHeaderCellDef>Allowed Next Statuses</th>
        <td mat-cell *matCellDef="let element">
          <div style="flex: 0 0 40%; display: flex; flex-wrap: wrap">
            @for (allowed of element.allowedStatuses ; track allowed; let i =
            $index) {
            <span class="app-multi-label">
              {{ allowed.name }}
              <button
                matIconButton
                matSuffix
                aria-label="Clear"
                class="small-icon-button"
                (click)="deleteAllowedStatus(element, i)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </span>
            }
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="add">
        <th mat-header-cell *matHeaderCellDef i18n="@@add">Add</th>
        <td mat-cell *matCellDef="let element">
          <mat-icon
            style="flex: 1 1 5%"
            (click)="addNextStatus(element)"
            class="app-button-label"
            >add</mat-icon
          >
        </td>
      </ng-container>
      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef i18n="@@edit">Edit</th>
        <td mat-cell *matCellDef="let element">
          <mat-icon style="flex: 1 1 10%" (click)="updateStatus(element)"
            >edit</mat-icon
          >
        </td>
      </ng-container>
      <ng-container matColumnDef="orderState">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          i18n="@@orderState"
        >
          Order State
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-select
            style="flex: 1 1 5%"
            (selectionChange)="updateOrderState(element, $event)"
            [(value)]="element.orderState"
          >
            <mat-option [value]="null">-</mat-option>
            @for (state of orderStates | keyvalue ; track state) {
            <mat-option [value]="+state.key">{{ state.value }}</mat-option>
            }
          </mat-select>
        </td>
      </ng-container>
      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef i18n="@@icon">Icon</th>
        <td mat-cell *matCellDef="let element">
          <mat-select
            style="flex: 1 1 32px"
            [compareWith]="compareFn"
            [(value)]="element.icon"
            (selectionChange)="updateStatusIcon(element, $event)"
          >
            <mat-select-trigger>
              <mat-icon [style]="{ color: element.iconColor }">{{
                element.icon?.name
              }}</mat-icon>
            </mat-select-trigger>
            @for (icon of statusIcons; track icon) {
            <mat-option [value]="icon">
              <mat-icon>{{ icon.name }}</mat-icon>
            </mat-option>
            }
          </mat-select>
        </td>
      </ng-container>
      <ng-container matColumnDef="color">
        <th mat-header-cell *matHeaderCellDef i18n="@@color">Color</th>
        <td mat-cell *matCellDef="let element">
          <input
            [cpDisableInput]="true"
            [cpCancelButton]="true"
            [cpOKButton]="true"
            [cpOutputFormat]="'hex'"
            [cpDialogDisplay]="'popup'"
            (colorPickerSelect)="updateStatusIconColor(element)"
            [(colorPicker)]="element.iconColor"
            [style.background]="element.iconColor"
            [cpPresetColors]="presetColors"
            id="color-picker"
          />
        </td>
      </ng-container>
      <ng-container matColumnDef="translations">
        <th mat-header-cell *matHeaderCellDef i18n="@@translations">Translations</th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-icon-button
            type="button"
            (click)="openTranslationsDialog(element)"
            [attr.aria-label]="element.translations ? 'Edit translations' : 'Add translations'"
          >
            <mat-icon color="primary">
              {{ element.translations ? 'translate' : 'add_comment' }}
            </mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4" i18n="@@NotMatchingFilter">
          No data matching the filter "{{ input.value }}"
        </td>
      </tr>
    </table>
  </mat-card-content>
</mat-card>
